export enum ScenarioFlavorEnum {
  allFlavors = 'all-flavors',
  campaignScenarios = 'campaign-scenarios',
  quickReplies = 'quick-replies',
  satisfactionSurvey = 'satisfaction-survey',
}
